import { FormattedMessage } from 'react-intl';
import { Grid, Typography, Stack } from 'components/ui';
import { GrayCard } from 'components/styles_components/card';
import { CardOptionTypography, CardOptionHintTypography } from 'components/styles_components/typography';
import State from 'components/inspection/state';
import Date from 'components/date';

const StatusCard = ({ inspection }) => (
  <Grid size={{ xs: 6, lg: 3 }}>
    <GrayCard>
      <Stack>
        <CardOptionTypography>
          <FormattedMessage id="inspection.status" />
        </CardOptionTypography>
        <Typography component="span">
          <State inspection={inspection} />
        </Typography>
      </Stack>
    </GrayCard>
  </Grid>
);

export default StatusCard;
